import { useState } from 'react';
import { Icon, TextField, Toggle } from '@fluentui/react';
import { t } from 'i18next';
import { IInformacionGeneral } from '../collaboratorCreateView';
import { Control, Controller, FieldValues } from 'react-hook-form';

interface EmailsSeguimientoProps extends IInformacionGeneral {
  control?: Control<FieldValues>;
}

export const EmailsSeguimiento = ({ errors, control, watch, setValue }: EmailsSeguimientoProps) => {
  const [isEnvioDirecto, setIsEnvioDirecto] = useState(false);
  const [prevValue, setPrevValue] = useState('');

  const colseg_mails = watch('colseg_mails');

  const handlerClick = (_: any, checked?: boolean) => {
    setIsEnvioDirecto(!!checked);

    if (checked) {
      setValue('colseg_mails', '', { shouldValidate: true, shouldDirty: true });
      setPrevValue(colseg_mails);
    } else {
      setValue('colseg_mails', prevValue, { shouldValidate: true, shouldDirty: true });
    }
  };

  return (
    <div className="form_informacion_general">
      <p className="titulo_form_create">
        <Icon iconName="MailReminder" style={{ fontSize: '25px' }} />
        {t('Notificación por correo')}
      </p>

      <div className="cuerpo_izquierdo_form">
        <span className="input_reusable">
          <Toggle label={t('Envio directo')} checked={isEnvioDirecto} onChange={handlerClick} />
        </span>

        {!isEnvioDirecto && (
          <div className="cuerpo_izquierdo_participacion">
            <Controller
              name="colseg_mails"
              control={control}
              rules={{
                required: !isEnvioDirecto,
                pattern: {
                  value: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}(,\s*[\w-.]+@([\w-]+\.)+[\w-]{2,4})*$/,
                  message: t('Debe ingresar correos válidos, separados por comas.'),
                },
              }}
              render={({ field }) => <TextField {...field} label={t('Emails que dará seguimiento a la carga del colaborador')} placeholder={t('Indique uno o más emails separados por comas')} styles={{ root: { width: '400px' } }} />}
            />

            {errors.colseg_mails?.type === 'required' && <span className="error_TextFile_proyectofijo">{t('El campo de emails no puede estar vacío.')}</span>}
            {errors.colseg_mails?.type === 'pattern' && <span className="error_TextFile_proyectofijo">{errors.colseg_mails.message}</span>}
          </div>
        )}
      </div>
    </div>
  );
};
